import React from 'react';
import Icon from '../../../components/AppIcon';

const UserMetrics = ({ statistics }) => {
  const metrics = [
    {
      label: 'Total Users',
      value: statistics?.totalUsers || 0,
      icon: 'Users',
      color: 'bg-blue-100 text-blue-600',
    },
    {
      label: 'Active Users',
      value: statistics?.activeUsers || 0,
      icon: 'UserCheck',
      color: 'bg-green-100 text-green-600',
    },
    {
      label: 'Inactive Users',
      value: statistics?.inactiveUsers || 0,
      icon: 'UserX',
      color: 'bg-gray-100 text-gray-600',
    },
    {
      label: 'Admins',
      value: statistics?.adminCount || 0,
      icon: 'Shield',
      color: 'bg-purple-100 text-purple-600',
    },
    {
      label: 'Managers',
      value: statistics?.managerCount || 0,
      icon: 'Briefcase',
      color: 'bg-orange-100 text-orange-600',
    },
    {
      label: 'Sales Staff',
      value: statistics?.salesCount || 0,
      icon: 'Target',
      color: 'bg-teal-100 text-teal-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
      {metrics?.map((metric, index) => (
        <div
          key={index}
          className="bg-white rounded-lg border border-gray-200 p-4 shadow-sm hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">{metric?.label}</p>
              <p className="text-2xl font-bold text-gray-900">{metric?.value}</p>
            </div>
            <div className={`p-3 rounded-lg ${metric?.color}`}>
              <Icon name={metric?.icon} size={24} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserMetrics;